//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonImg from '@/components/views/common_img'
import ImgWrap from '@/components/business/img_wrap'
import common_utils from './_house_item_utils.js'
export default {
    mixins: [
        common_utils
    ],
    methods: {
        goLink (e) {
            this.$emit('goLink', e)
        }
    },
    components: {
        CommonImg,
        ImgWrap
    },
    props: {
        item: {
            type: Object
        },
        index: {
            type: [Number, String]
        }
    }
}
